<div>
  <a
    (click)="toggleLanguageDropdown()"
    class="flex items-center gap-sm px-md cursor-pointer">
    <lib-globe-icon iconClass="size-6 text-neutral-500" />

    <span class="text-sm text-neutral-500 font-medium">{{
      currentLanguage() === 'ar'
        ? ('navbar_language_dropdown_ar' | transloco)
        : ('navbar_language_dropdown_en' | transloco)
    }}</span>

    <i
      [class.rotate-180]="isLanguageDropdownOpen()"
      [class.rotate-0]="!isLanguageDropdownOpen()">
      <lib-chevron-down-icon
        iconClass="size-5"
        stroke="var(--color-neutral-500)" />
    </i>
  </a>

  @if (isLanguageDropdownOpen()) {
    <div
      libClickOutSide
      [stopPropagations]="true"
      (clickOutside)="isLanguageDropdownOpen.set(false)"
      class="actions-container flex flex-col absolute bg-white shadow-xl rounded-lg items-center p-lg gap-lg font-semibold">
      <div
        class="flex justify-between items-center w-full cursor-pointer"
        (click)="switchLanguage('ar')">
        <a
          class="font-main-ar min-w-[6rem]"
          [class]="
            currentLanguage() === 'ar' ? 'text-primary-500' : 'text-neutral-900'
          ">
          {{ 'navbar_language_dropdown_ar' | transloco }}
        </a>

        @if (currentLanguage() === 'ar') {
          <lib-check-icon
            iconClass="size-5 do-not-transform text-primary-500" />
        }
      </div>

      <div
        class="flex justify-between items-center w-full cursor-pointer"
        (click)="switchLanguage('en')">
        <a
          class="font-main-en min-w-[6rem]"
          [class]="
            currentLanguage() === 'en' ? 'text-primary-500' : 'text-neutral-900'
          ">
          {{ 'navbar_language_dropdown_en' | transloco }}
        </a>

        @if (currentLanguage() === 'en') {
          <lib-check-icon
            iconClass="size-5 do-not-transform text-primary-500" />
        }
      </div>
    </div>
  }
</div>
